export const downloadFileByUrl = async (url, fileName = 'download') => {
	if (!url) return
	if (!url.startsWith(location.origin)) {
		const tempUrl = new URL(url)
		url = location.origin + tempUrl.pathname
	}
	const response = await fetch(url)
	const blob = await response.blob()
	await downloadBlob(blob, fileName)
}

export const downloadBlob = async (blob, fileName = 'download') => {
	if (!blob) return
	const objectUrl = URL.createObjectURL(blob)
	const link = document.createElement('a')
	link.href = objectUrl
	link.download = fileName
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
	URL.revokeObjectURL(objectUrl)
}

export const compressBlob = async (blob, type = 'gzip') => {
	if (!window.CompressionStream || !blob?.stream) return blob
	const compressionStream = new CompressionStream(type)
	const compressedStream = blob.stream().pipeThrough(compressionStream)
	const response = new Response(compressedStream)
	const compressedBlob = await response.blob()
	return compressedBlob
}

export const decompressBlob = async (blob, type = 'gzip') => {
	const decompressionStream = new DecompressionStream(type)
	const decompressedStream = blob.stream().pipeThrough(decompressionStream)
	const response = new Response(decompressedStream)
	const decompressedBlob = await response.blob()
	return decompressedBlob
}
